export const FAV_COLORS = ["#FCE9D2", "#FCF8D6", "#DFF3E3", "#DCE6F2", "#F9DDE3", "#E8E1F5", "#D9F2EF", "#E9ECEF"];
export const favPages = (view) => view.shop?.favorites || [];
export const favItems = (view, page) => (page?.items || [])
  .map((i) => ({ p: view.products?.[i.product_id], color: i.color }))
  .filter((x) => x.p && !x.p.deleted);
